/**
 * Factory for a tenant enhancer that captures current tenantId
 */
export function createTenantEnhancer(getTenantId: () => string | undefined) {
  return () => {
    const tenantId = getTenantId();
    return tenantId ? { tenant: { id: tenantId } } : {};
  };
}
